import { TExternalLink } from "@/types/TExternalLink"
import { Globe, Phone, Mail } from "lucide-react";

type TExternalLinkProps = {
  item: TExternalLink
}

export default function ExternalLink({item: { value, type, originalText }}: TExternalLinkProps) {
  const getHref = () => {
    switch (type) {
      case "email":
        return `mailto:${value}`;
      case "phone":
        return `tel:${value}`;
      default:
        return value;
    }
  }

  const getIcon = () => {
    switch (type) {
      case "email":
        return <Mail strokeWidth={1.5} className="w-5 h-5" />;
      case "phone":
        return <Phone strokeWidth={1.5} className="w-5 h-5" />;
      default:
        return <Globe strokeWidth={1.5} className="w-5 h-5" />;
    }
  }

  return (
    <a
      href={getHref()}
      target={"_blank"}
      rel={type === "url" ? "noopener noreferrer" : undefined}
      className="flex gap-4 items-center rounded-full bg-cta py-1 px-4 text-white w-full border-2 border-transparent hover:border-cta hover:bg-white hover:text-cta"
    >
      <div>{getIcon()}</div>
      <div className="flex-1 truncate">{originalText || value}</div>
    </a>
  )
}